import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ButtonToolbar } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { SubmissionError } from "redux-form";
import classNames from "classnames";

import { CheckboxButton, ArchiveButton, EditButton } from "../../../common";
import { DataTable } from "../../../common/DataTable";
import BasicBlocFields from "./BasicBlocFields";

import { BLOCS } from "../../../../utils/data/models";
import * as dataActions from "../../../../utils/data/dataActions";
import * as types from "../../../../utils/data/dataActionTypes";
import { Link } from "react-router";

class BlocsDataTable extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.archiveBloc = this.archiveBloc.bind(this);
    this.createEmptyBlocModel = this.createEmptyBlocModel.bind(this);
    this.createBloc = this.createBloc.bind(this);
    this.getData = this.getData.bind(this);
    this.setCellClassNames = this.setCellClassNames.bind(this);
    this.toggleArchivedBlocs = this.toggleArchivedBlocs.bind(this);
    this.updateBloc = this.updateBloc.bind(this);
  }

  componentWillMount() {
    this.props.dataActions.clearDataList(BLOCS);
  }

  archiveBloc(blocId, isArchived) {
    this.props.dataActions
      .updateDataItem(BLOCS, { blocId, isArchived: !isArchived })
      .then(() => {
        this.getData(
          this.props.offset,
          this.props.limit,
          this.props.q,
          this.props.sortBy,
          this.props.filters
        );
      });
  }

  createEmptyBlocModel() {
    return {
      name: "",
    };
  }

  createBloc(model) {
    const newModel = { ...model };
    return this.props.dataActions
      .createDataItem(BLOCS, newModel)
      .then((data) => {
        this.getData(
          this.props.offset,
          this.props.limit,
          this.props.q,
          this.props.sortBy,
          this.props.filters,
          data
        );
      });
  }

  setCellClassNames(bloc, customClass = false) {
    return classNames({
      archived: bloc.isArchived,
      [customClass]: !!customClass,
    });
  }

  toggleArchivedBlocs() {
    const isArchivedFiltered = this.props.filters.includes(BLOCS.archiveFilter);
    const filters = isArchivedFiltered
      ? this.props.filters.filter((filter) => filter !== BLOCS.archiveFilter)
      : [...this.props.filters, BLOCS.archiveFilter];
    this.getData(
      this.props.offset,
      this.props.limit,
      this.props.q,
      this.props.sortBy,
      filters
    );
  }

  updateBloc(model) {
    const newModel = { ...model };
    return this.props.dataActions
      .updateDataItem(BLOCS, newModel)
      .then((data) => {
        this.getData(
          this.props.offset,
          this.props.limit,
          this.props.q,
          this.props.sortBy,
          this.props.filters,
          data
        );
      });
  }

  getCols() {
    return [
      {
        name: <FormattedMessage id="admin.blocs.datatable.columns.name" />,
        key: "name",
        display: (bloc) => {
          const text = (
            <span className={this.setCellClassNames(bloc)}>{bloc.name}</span>
          );

          if (bloc.isArchived) {
            return text;
          }

          return (
            <Link
              onlyActiveOnIndex={false}
              to={`dashboard/admin/blocs/${bloc.blocId}`}
              title={bloc.name}
            >
              {text}
            </Link>
          );
        },
        widthPct: 40,
      },
      {
        name: (
          <FormattedMessage id="admin.blocs.datatable.columns.clientCount" />
        ),
        display: (bloc) => (
          <span className={this.setCellClassNames(bloc)}>
            {bloc.clients.length}
          </span>
        ),
        widthPct: 40,
      },
      {
        name: <FormattedMessage id="datatable.actions" />,
        display: (bloc) => this.generateActionButtons(bloc),
        widthPct: 20,
      },
    ];
  }
  renderFormatedMessage(icon) {
    return <span className="icon warning">{icon}</span>;
  }
  generateActionButtons(bloc) {
    return (
      <ButtonToolbar key={bloc.blocId}>
        <EditButton
          title={<FormattedMessage id="admin.blocs.datatable.actions.edit" />}
          confirmationTitle={
            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.title">
              {this.renderFormatedMessage}
            </FormattedMessage>
          }
          confirmationMessage={
            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.message" />
          }
          closeButtonKey="common.cancel"
          requiresCloseConfirmation={true}
          confirmOnClose={true}
          form={BasicBlocFields}
          props={{ clients: this.props.clients }}
          label={<FormattedMessage id="common.edit" />}
          data={{ blocId: bloc.blocId, name: bloc.name }}
          editFunction={this.updateBloc}
        />
        {!bloc.isArchived && (
        <ArchiveButton
          isArchived={bloc.isArchived}
          archivedName={bloc.emailAddress}
          warningMessage={
            bloc.isArchived ? (
              ""
            ) : (
              <FormattedMessage id="admin.blocs.datatable.actions.archiveWarning" />
            )
          }
          archiveFunction={this.archiveBloc.bind(
            null,
            bloc.blocId,
            bloc.isArchived
          )}
          label={
            bloc.isArchived ? (
              <FormattedMessage id="common.unarchive" />
            ) : (
              <FormattedMessage id="common.archive" />
            )
          }
        />          
      )}
      </ButtonToolbar>
    );
  }

  generateAddButton() {
    return (
      <div>
        <CheckboxButton
          className="include-archived"
          id="archived"
          label={
            <FormattedMessage id="admin.blocs.datatable.actions.includeArchivedBlocs" />
          }
          checked={!this.props.filters.includes(BLOCS.archiveFilter)}
          onClick={this.toggleArchivedBlocs}
        />
        <EditButton
          title={<FormattedMessage id="admin.blocs.datatable.actions.add" />}
          requiresCloseConfirmation={true}
          confirmOnClose={true}
          label={<FormattedMessage id="common.add" />}
          add={true}
          form={BasicBlocFields}
          data={this.createEmptyBlocModel()}
          editFunction={this.createBloc}
          confirmationTitle={
            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.title">
              {this.renderFormatedMessage}
            </FormattedMessage>
          }
          confirmationMessage={
            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.message" />
          }
          closeButtonKey="common.cancel"
        />
      </div>
    );
  }
  getData(offset, limit, q, sortBy, filters, action = {}) {
    switch (action.type) {
      case types.CREATE_DATA_ITEM_FAILURE:
      case types.UPDATE_DATA_ITEM_FAILURE: {
        if (action.payload.error.data.error === "duplicateBlocName") {
          throw new SubmissionError({
            name: {
              messageKey:
                "validation.customMessages.serverErrors.duplicateBlocName",
              values: {},
              state: "error",
            },
          });
        }
        throw new SubmissionError({
          name: {
            messageKey: "validation.customMessages.serverErrors.genericError",
            values: {},
            state: "error",
          },
        });
      }
      default: {
        return this.props.dataActions.getDataList(
          BLOCS,
          offset,
          limit,
          q,
          sortBy,
          filters
        );
      }
    }
  }

  render() {
    return (
      <DataTable
        ref="dataTable"
        title={<FormattedMessage id="admin.blocs.title" />}
        getData={this.getData}
        cols={this.getCols()}
        offset={this.props.offset}
        q={this.props.q}
        filters={this.props.filters}
        data={this.props.blocs}
        rowsPerPage={this.props.limit}
        totalRows={this.props.total}
        sortBy={this.props.sortBy}
        addButton={this.generateAddButton()}
      />
    );
  }
}

BlocsDataTable.propTypes = {
  auth: PropTypes.object,
  clients: PropTypes.array,
  dataActions: PropTypes.object,
  q: PropTypes.string,
  filters: PropTypes.array,
  limit: PropTypes.number,
  offset: PropTypes.number,
  sortBy: PropTypes.array,
  total: PropTypes.number,
  blocs: PropTypes.array,
};

function mapStateToProps(state) {
  const data = state.data.blocs || {};
  const pagination = data.pagination || {};

  return {
    auth: state.auth || {},
    limit: pagination.limit || 100,
    q: data.q,
    filters: data.filters || [BLOCS.archiveFilter],
    offset: pagination.offset || 0,
    sortBy: data.sortBy || ["name:asc"],
    total: pagination.totalCount || 0,
    blocs: data.items || null,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BlocsDataTable);



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/blocs/BlocsDataTable.js